(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const seoFooter = document.querySelector('[data-js="collection-seo-footer"]');

    if (!seoFooter) {
      return;
    }

    window.setTimeout(() => {
      seoFooter.style.display = "none";
    }, 3000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-page-redirect"]) return;
  try {
    
  document.querySelectorAll('[data-js="product-redirect"][data-redirect-url]').forEach((element) => {
    const redirectUrl = element.getAttribute("data-redirect-url");

    if (!redirectUrl || window.location.pathname === redirectUrl) {
      return;
    }

    window.location.replace(redirectUrl);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-redirect"]) return;
  try {
    
  document.querySelectorAll('[data-js="product-redirect"][data-redirect-url]').forEach((element) => {
    const redirectUrl = element.getAttribute("data-redirect-url");

    if (!redirectUrl || window.location.pathname === redirectUrl) {
      return;
    }

    window.location.replace(redirectUrl);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const recommendationRoots = document.querySelectorAll('[data-js="product-recommendations"]');

    recommendationRoots.forEach((root) => {
      if (root.dataset.jsInitialized === 'true') {
        return;
      }

      root.dataset.jsInitialized = 'true';

      if (root.dataset.recommendationsReady === 'true') {
        return;
      }

      const requestUrl = new URL(root.dataset.url, window.location.origin);
      requestUrl.searchParams.set('section_id', root.dataset.sectionId || '');
      requestUrl.searchParams.set('product_id', root.dataset.productId || '');
      requestUrl.searchParams.set('limit', root.dataset.limit || '');
      requestUrl.searchParams.set('intent', 'related');

      fetch(requestUrl.toString())
        .then((response) => response.text())
        .then((markup) => {
          const parser = new DOMParser();
          const documentRoot = parser.parseFromString(markup, 'text/html');
          const nextRoot = documentRoot.querySelector('[data-js="product-recommendations"]');

          if (!nextRoot || nextRoot.dataset.recommendationsReady !== 'true') {
            root.remove();
            return;
          }

          root.replaceWith(nextRoot);
          document.dispatchEvent(new Event('shopify:section:load'));
        })
        .catch(() => {
          root.remove();
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-detail"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
      var elements = document.querySelectorAll('.hide-after-load');
      elements.forEach(function (element) {
        element.style.display = 'none';
      });
    }, 3000);

    document.querySelectorAll('.store-locator__single video[autoplay]').forEach(function (videoEl) {
      videoEl.muted = true;
      var playPromise = videoEl.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    });

    var locator = document.querySelector('.store-locator__single');
    if (!locator) return;

    var lat = parseFloat(locator.dataset.lat || '');
    var lng = parseFloat(locator.dataset.lng || '');
    var hasCoordinates = !Number.isNaN(lat) && !Number.isNaN(lng);
    var storeAddress = String(locator.dataset.address || '').trim();
    if (!hasCoordinates && storeAddress.length === 0) return;
    var mapStyles = [
      { elementType: 'geometry', stylers: [{ color: '#f5f5f5' }] },
      { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
      { elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
      { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f5f5' }] },
      { featureType: 'administrative.land_parcel', elementType: 'labels.text.fill', stylers: [{ color: '#bdbdbd' }] },
      { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#eeeeee' }] },
      { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
      { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#e5e5e5' }] },
      { featureType: 'poi.park', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] },
      { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
      { featureType: 'road.arterial', elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
      { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#dadada' }] },
      { featureType: 'road.highway', elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
      { featureType: 'road.local', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] },
      { featureType: 'transit.line', elementType: 'geometry', stylers: [{ color: '#e5e5e5' }] },
      { featureType: 'transit.station', elementType: 'geometry', stylers: [{ color: '#eeeeee' }] },
      { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#c9c9c9' }] },
      { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] },
    ];

    function renderMaps(center) {
      if (!center) return;

      var markerIcon = 'https://atelier-vm.s3.amazonaws.com/uploads/file_uploader/image/8/dot.png';
      if (!window.google || !window.google.maps) return;

      var desktopMapEl = document.getElementById('map');
      var mobileMapEl = document.getElementById('map_mobile');

      if (desktopMapEl) {
        var desktopMap = new google.maps.Map(desktopMapEl, {
          center: center,
          zoom: 16,
          styles: mapStyles,
          disableDefaultUI: true,
        });
        new google.maps.Marker({
          position: center,
          map: desktopMap,
          icon: markerIcon,
        });
      }

      if (mobileMapEl) {
        var mobileMap = new google.maps.Map(mobileMapEl, {
          center: center,
          zoom: 16,
          styles: mapStyles,
          disableDefaultUI: true,
        });
        new google.maps.Marker({
          position: center,
          map: mobileMap,
          icon: markerIcon,
        });
      }
    }

    function initStoreMaps() {
      if (!window.google || !window.google.maps) return;

      if (hasCoordinates) {
        renderMaps({ lat: lat, lng: lng });
        return;
      }

      if (storeAddress.length > 0) {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address: storeAddress }, function (results, status) {
          if (status !== 'OK' || !results || !results[0] || !results[0].geometry || !results[0].geometry.location) return;

          var resolvedCenter = {
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng(),
          };

          renderMaps(resolvedCenter);
        });
      }
    }

    if (window.google && window.google.maps) {
      initStoreMaps();
      return;
    }

    var existingScript = document.getElementById('store-detail-google-maps');
    if (existingScript) {
      window.addEventListener('store-detail:maps-ready', initStoreMaps, { once: true });
      return;
    }

    window.addEventListener('store-detail:maps-ready', initStoreMaps, { once: true });
    window.__storeDetailGoogleMapsReady = function () {
      window.dispatchEvent(new Event('store-detail:maps-ready'));
    };

    var script = document.createElement('script');
    script.id = 'store-detail-google-maps';
    script.src =
      'https://maps.googleapis.com/maps/api/js?key=AIzaSyBBOSxDSg-3qle4wJVBR-j14U7A5lI29Gs&v=weekly&callback=__storeDetailGoogleMapsReady';
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-player"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pauseOtherVideos = (currentVideo) => {
      document.querySelectorAll(".video-player-section video").forEach((videoNode) => {
        if (videoNode !== currentVideo && !videoNode.paused) {
          videoNode.pause();
        }
      });
    };

    const initVideoPlayer = (root) => {
      const playButton = root.querySelector('[data-js="video-player-play"]');
      const video = root.querySelector("video");

      if (!playButton || !video) {
        return;
      }

      const hidePlayButton = () => {
        playButton.classList.add("opacity-0", "pointer-events-none");
      };

      const showPlayButton = () => {
        if (video.ended || video.paused) {
          playButton.classList.remove("opacity-0", "pointer-events-none");
        }
      };

      playButton.addEventListener("click", async () => {
        try {
          pauseOtherVideos(video);
          await video.play();
          hidePlayButton();
        } catch (_) {
          showPlayButton();
        }
      });

      video.addEventListener("play", () => {
        pauseOtherVideos(video);
        hidePlayButton();
      });
      video.addEventListener("pause", showPlayButton);
      video.addEventListener("ended", showPlayButton);
    };

    document.querySelectorAll(".video-player-section").forEach(initVideoPlayer);
  })();

  } catch(e) { console.error(e); }
})();
})();
